import type { AccountStore } from './account.type'

export const accountInitialState: Pick<
  AccountStore,
  'profile' | 'signInMethods' | 'twoFactorStatus' | 'themePreference' | 'loading' | 'error'
> = {
  profile: null,
  signInMethods: [],
  twoFactorStatus: null,
  themePreference: 'system',
  loading: false,
  error: null,
}
